import { BANKID_QUERY_PARAMS } from "@utils/specific/bankid/bankIdConstants";

const CANCEL_ERROR_CODE = "CANCELLED_BY_USER";
const CANCEL_SESSION_STATUS = "Cancelled";

export function isBankIdRedirectCancel(
	search: string = window.location.search
): boolean {
	const params = new URLSearchParams(search);
	return (
		params.get("errorCode") === CANCEL_ERROR_CODE ||
		params.get("sessionStatus") === CANCEL_SESSION_STATUS
	);
}

export function hasBankIdRedirectFailure(
	search: string = window.location.search
): boolean {
	const params = new URLSearchParams(search);
	return Boolean(
		params.get("failedAuth") ||
			params.get("errorCode") ||
			params.get("errorDetails")
	);
}

export function bankIdRedirectMessageKey(isCancel: boolean): string {
	return isCancel
		? "specific:MEMBERSHIP.REGISTRATION.BANKID.AUTH_FAILED"
		: "specific:MEMBERSHIP.REGISTRATION.BANKID.AUTH_NOT_VALID";
}

export function clearBankIdRedirectParams(): void {
	const params = new URLSearchParams(window.location.search);
	BANKID_QUERY_PARAMS.forEach((param) => params.delete(param));

	const query = params.toString();
	window.history.replaceState(
		{},
		"",
		window.location.pathname + (query ? `?${query}` : "")
	);
}
